import * as DIAG from "storm-react-diagrams";
export default class FolderNodeModel extends DIAG.DefaultNodeModel {
    /**
     * Folder node model
     * @module FolderNodeModel
     * @param {string} nodeName Node display name
     * @param {Object} props Pre-defined node properties; if non-null, apply values to node properties
     * @param {string} id If non-null, use this ID as the node ID
     */
    constructor(nodeName = "UNTITLED_FOLDER", props = null, id = null) {
        super(nodeName, null, id);
        this.props = {
            nodeTypeName: "Folder",
            config: {},
            error: {},
            configView: []
        };
    }

    /**
     * Set error with key
     * @param {string} key Tracking key; error ID
     * @param {string} message
     */
    setError(key, message) {
        this.props.error[key] = message;
    }

    /**
     * Remove error with key
     * @param {string} key Tracking key; error ID
     */
    removeError(key) {
        delete this.props.error[key];
    }

    /**
     * Does this model have any error?
     * @returns {boolean}
     */
    hasError() {
        return Object.keys(this.props.error).length > 0;
    }

    /**
     * Get the last error message
     * @returns {string}
     */
    getError() {
        const e = Object.values(this.props.error);
        if (e.length) {
            return e[e.length - 1];
        }
        return "";
    }

    getConfigViewNameField() {
        var nameField = [{ type: "Input", label: this.getPropLabel("name"), key: "name", valRules: { "noEmpty": true, "objectName": true , "noDuplicateFolder": true} }];
        if (this.hasWriteProxy()) {
            nameField = [{
                type: "Input",
                label: this.getPropLabel("name"),
                key: "name",
                valRules: { "noEmpty": true, "objectName": true , "noDuplicateFolder": true }
            }];
        }
        return nameField;
    }

    getConfig(key) {
        if (key === "name") {
            return this.name;
        }
        return this.props.config[key];
    }

    setConfig(key, value) {
        const valueClone = JSON.parse(JSON.stringify(value));
        if (key === "name") {
            this.name = valueClone;
        }
        if (this.hasWriteProxy()) {
            this.writeProxy(key, valueClone);
        }
    }

    getPropLabel(key) {
        return window.l.property[key];
    }

    hasWriteProxy() {
        return this.writeProxy && (typeof this.writeProxy === "function");
    }

    getConfigViews() {
            return [
                ...this.getConfigViewNameField()
            ]; 
    }
}
